import { jsx as _jsx } from "react/jsx-runtime";
import { atom, useAtom } from "jotai";
import { atomFamily } from "jotai/utils";
import Drawer from "@mui/material/Drawer";
/**
 * Allow to control {@linkcode ConfigurationNavigation}
 */
export const configurationDrawerState = atomFamily((_param) => atom(true));
/**
 * Shows content in a drawer
 * @param props
 * @returns
 */
export function ConfigurationDrawer(props) {
    const { drawerId = "default" } = props;
    const [isOpen, setIsOpen] = useAtom(configurationDrawerState(drawerId));
    return (_jsx(Drawer, { open: isOpen, onClose: () => setIsOpen(false), variant: props.drawerVariant, children: props.children }));
}
//# sourceMappingURL=ConfigurationDrawer.js.map